import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Content from "../../../Components/Dashboard/Content/Content";
const CoinDCXGuide = () => {
  const toggleTheme = () => {
    document.body.classList.toggle("bg-dark");
    document.body.classList.toggle("text-white");
  };

  return (
    <Content Page_title="All Api-Create Info's" button_status={true} button_title="Back" route={"/client/apicreateinfo"}>
      <div className="container pb-5 px-0  Api-Create-Info">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center ">
          <h5 className="">CoinDCX API Dashboard Guide</h5>

        </div>

        {/* Intro */}
        <div className="mb-4">
          <p>
            You can find the <strong>API dashboard</strong> in the Profile section of the CoinDCX Web Platform.
            It allows you to:
          </p>
          <ul>
            <li>
              {" "}
              Login Url :{" "}
              <a
                href="https://coindcx.com/login"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://coindcx.com/login
              </a>
            </li>
            <li>Generate API Key and Secret</li>
            <li>Manage pre-existing API Keys</li>
          </ul>
        </div>

        {/* Access API Dashboard */}
        <div className=" mb-4">
          <h4 className="fw-semibold mb-3">How to Access API Dashboard</h4>
          <ol className="ps-3">
            <li>Go to the Profile icon on the top-right corner of the CoinDCX dashboard.</li>
            <li>Click on <strong>Profile</strong>. You’ll be redirected to the My Profile page.</li>
            <li>Select <strong>API Dashboard</strong> from the left-hand menu.</li>
          </ol>
          <img
            src="https://coindcx.com/api/help/assets/images/coindcxwebdash-7ccb87854ea60a0815c381a3c49156a5.png"
            alt="Profile Icon"
            className="img-fluid rounded mt-3"
          />
          <img
            src="https://coindcx.com/api/help/assets/images/myprofile-14425dec2870808ce0f8aad080736cb2.png"
            alt="My Profile"
            className="img-fluid rounded mt-3"
          />
        </div>

        {/* Create API Key */}
        <div className=" mb-4">
          <h4 className="fw-semibold mb-3">Creating a New API Key</h4>
          <ol className="ps-3">
            <li>Go to the <strong>API Dashboard</strong> and click <strong>Create A New One</strong>.</li>
            <li>Enter a name and optionally bind an IP address. Click <strong>SEND OTP</strong>.</li>
            <li>Enter the OTP received via email/SMS and click <strong>CREATE</strong>.</li>
            <li><span className="text-warning fw-bold">Note:</span> The <strong>Secret</strong> will be hidden forever after page refresh. Store it safely.</li>
          </ol>
          <img
            src="https://coindcx.com/api/help/assets/images/apidashboard-319a3eafce5bb57a38e7796095c08d87.png"
            alt="API Dashboard"
            className="img-fluid rounded mt-3"
          />
          <img
            src="https://coindcx.com/api/help/assets/images/apikeyverification-eef844d29dd8dec2ee546ca13e29594f.png"
            alt="API Key Verification"
            className="img-fluid rounded mt-3"
          />
        </div>

        {/* Retrieve API Key */}
        <div className=" mb-4">
          <h4 className="fw-semibold mb-3">Retrieving an API Key</h4>
          <p>On the API Dashboard, you can retrieve the key in three ways:</p>
          <ul className="ps-3">
            <li>Scan the QR code shown on the screen</li>
            <li>Click the copy icon to copy to clipboard</li>
            <li>Use the read icon to view the key</li>
          </ul>
          <img
            src="https://coindcx.com/api/help/assets/images/retrievetheapikey-a2df0726903682c3d3287fefb88b1411.png"
            alt="Retrieve API Key"
            className="img-fluid rounded mt-3"
          />
          <div className="alert alert-warning mt-4" role="alert">
            <strong>⚠️ Important:</strong> The Secret key cannot be recovered after creation. Save it securely.
          </div>
        </div>
      </div>
    </Content>
  );
};

export default CoinDCXGuide;
